import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Component, Injectable, OnInit } from '@angular/core';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, retry } from 'rxjs/operators';
import { Common } from '../../common';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(public dialogService: DialogService, public dialog?: DialogRef) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tk = localStorage.getItem('sp-token');
    if (tk) {
      req = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + tk) });
    }

    if ((req.headers.get('Content-Type') === 'undefined')) {
      req = req.clone({ headers: req.headers.delete('Content-Type') });
    }
    req = req.clone({ headers: req.headers.set('Access-Control-Allow-Origin', '*') });
    req = req.clone({ headers: req.headers.set('Access-Control-Allow-Headers', '*') });
    req = req.clone({ headers: req.headers.set('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, PUT, PATCH, DELETE') });

    return next.handle(req)
      .pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          let errorMessage = '';
          if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
          } else {
            // server-side error
            errorMessage = `Error Code: ${error.statusText}<br>Message: ${error.error}`;
          }
          if (error.status === 401 && error.message.includes('GetUser')) {
            window.location.href = error.headers.get('Location');
          } else if (error.status === 401) {
            const dialogRef = this.dialogService.open({
              title: 'Error',
              width: 400,
              content: ErrorContentComponent,
              actions: [
                { text: 'Ok', primary: true }
              ],
            });
            const errorInfo = dialogRef.content.instance;
            errorInfo.errorStatus = error.status;
            errorInfo.errorStatusText = error.statusText;
            errorInfo.errorMessage = error.error;
            errorInfo.flag = true;
          } else if (error.status === 200) {
            // do nohitng
          } else {
            const dialogRef = this.dialogService.open({
              title: 'Error',
              width: 400,
              content: ErrorContentComponent,
              actions: [
                { text: 'Ok', primary: true }
              ],
            });
            const errorInfo = dialogRef.content.instance;
            errorInfo.flag = false;
          }
          return throwError(errorMessage);
        }
        ),
        finalize(() => {
          Common.loader('hide');
        })
      );
  }

  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.statusText}<br>Message: ${error.error}`;
    }
    if (error.status === 401 && error.message.includes('GetUser')) {
      window.location.href = error.headers.get('Location');
    } else if (error.status === 401) {
      const dialogRef = this.dialogService.open({
        title: 'Error',
        width: 400,
        content: ErrorContentComponent,
        actions: [
          { text: 'Ok', primary: true }
        ],
      });
      const errorInfo = dialogRef.content.instance;
      errorInfo.errorStatus = error.status;
      errorInfo.errorStatusText = error.statusText;
      errorInfo.errorMessage = error.error;
      errorInfo.flag = true;
      // return throwError(errorMessage);
    } else if (error.status === 200) {
      // do nohitng
    } else {
      const dialogRef = this.dialogService.open({
        title: 'Error',
        width: 400,
        content: ErrorContentComponent,
        actions: [
          { text: 'Ok', primary: true }
        ],
      });
      const errorInfo = dialogRef.content.instance;
      errorInfo.flag = false;
      // return throwError(errorMessage);
    }


    // window.alert(errorMessage);
    return throwError(errorMessage);
  }
}


@Component({
  selector: 'app-error-content',
  templateUrl: 'error-content.html',
})
export class ErrorContentComponent implements OnInit {
  errorStatus: string;
  errorStatusText: string;
  errorMessage: string;
  flag: boolean;

  constructor() { }

  ngOnInit() {
  }
}
